import * as AppConstants from 'app/AppConstants';

export default (state = {}, action) => {
  switch (action.type) {
    case AppConstants.PEOPLE__SEARCH:
      return {...state, query: action.payload.query};
    case AppConstants.PEOPLE__SEARCH_RESULTS:
      return {...state, results: action.payload.results};
    case AppConstants.PEOPLE__SEARCH_RESET:
      return {};
    default:
      return state;
  }
};
